/**
 * PersonalDataCategory.dataType — KVKK m.6 aligned taxonomy.
 *
 * - `genel`: ordinary personal data (outside Art. 6)
 * - `ozel`: special-category umbrella / unspecified Art. 6 subtype (parent rows)
 * - remaining values: explicit Art. 6 special categories
 */

export const PERSONAL_DATA_CATEGORY_DATA_TYPES = [
    'genel',
    'ozel',
    'irk_etnik',
    'siyasi',
    'din_inanc',
    'kilik_kiyafet',
    'uyelik',
    'saglik',
    'cinsel_hayat',
    'ceza',
    'biyometrik',
    'genetik',
];

/** Art. 6 special-category codes (everything except ordinary `genel`). */
export const SPECIAL_PERSONAL_DATA_TYPES = PERSONAL_DATA_CATEGORY_DATA_TYPES.filter(
    (v) => v !== 'genel',
);

/** Ordered options for forms: general first, then m.6 list, then umbrella `ozel`. */
export const PERSONAL_DATA_CATEGORY_DATA_TYPE_OPTIONS = [
    'genel',
    'irk_etnik',
    'siyasi',
    'din_inanc',
    'kilik_kiyafet',
    'uyelik',
    'saglik',
    'cinsel_hayat',
    'ceza',
    'biyometrik',
    'genetik',
    'ozel',
];

export function isSpecialPersonalDataType(dataType) {
    return Boolean(dataType) && dataType !== 'genel';
}
